<template>
  <div id="wizard" class="mb-10">
    <v-overlay color="#000" opacity="0.40" :absolute="true" :value="isLoading" :z-index="3">
      <v-progress-circular indeterminate color="primary" :size="60" :width="5" class="mr-10px" />
      {{ loadingMessage }}
    </v-overlay>
    <!-- DEBUG zastupcovia -->
    <v-card class="debug-card pa-2" v-if="debug">
      <h2>Zastupca data</h2>
      <v-card-actions>
        <v-btn
          v-for="(zas, i) in zastupcovia"
          :key="i"
          class="btn-secondary"
          icon
          @click="zasDebugIndex = i"
          >{{ zas.id_zastupcu }}</v-btn
        >
      </v-card-actions>
      <v-card-text>
        <table v-if="zastupcovia">
          <tr v-for="[key, value] in getZastupcoviaDebugEntries()" :key="key">
            <th>{{ key }}:</th>
            <td class="pl-2">{{ value }}</td>
          </tr>
        </table>
      </v-card-text>
    </v-card>
    <!-- DEBUG najomca -->
    <v-card class="debug-card debug-najomca pa-2" v-if="debug">
      <h2>Najomca data</h2>
      <v-card-text>
        <table>
          <tr v-for="[key, value] in Object.entries(najomca)" :key="key">
            <th>{{ key }}:</th>
            <td class="pl-2">{{ value }}</td>
          </tr>
        </table>
      </v-card-text>
    </v-card>
    <v-container class="pa-0 form-najomca">
      <v-form ref="form" autocomplete="off">
        <h1 class="my-25px">Nájomca</h1>
        <v-card class="card">
          <v-row>
            <v-col xl="9" lg="9" md="9">
              <button-group
                switchBtn
                :data="formaPodnData"
                v-model="najomca.id_formy_podn"
                :isEnabled="getNajomcaParameter('isEnabled', 'id_formy_podn')"
                :required="getNajomcaParameter('isRequired', 'id_formy_podn')"
              />
            </v-col>
          </v-row>
          <!-- ####### -->
          <!-- PO, FOP -->
          <!-- ####### -->
          <div
            :class="{ 'mt-8': najomca.id_formy_podn !== 2 }"
            v-if="najomca.id_formy_podn < 3"
            :key="najomca.id_formy_podn"
          >
            <v-row v-if="najomca.id_formy_podn === 2">
              <v-col xl="4" lg="4" md="4">
                <v-checkbox
                  class="dynamic_check_box"
                  label="Podniká na rodné číslo"
                  v-model="najomca.podnika_na_rc"
                  :disabled="!getNajomcaParameter('isEnabled', 'podnika_na_rc')"
                  :false-value="0"
                  :true-value="1"
                />
              </v-col>
            </v-row>
            <v-row
              v-if="
                najomca.id_formy_podn === 1 ||
                (najomca.id_formy_podn === 2 && !najomca.podnika_na_rc)
              "
            >
              <v-col xl="4" lg="4" md="4">
                <text-box
                  label="IČO"
                  :isEnabled="getNajomcaParameter('isEnabled', 'ico')"
                  :required="getNajomcaParameter('isRequired', 'ico')"
                  v-model="najomca.ico"
                  :removeCharacters="/[^\d]/g"
                />
              </v-col>
              <v-col xl="4" lg="4" md="4">
                <text-box
                  placeholder="Obchodné meno nájomcu"
                  label="Obchodné meno"
                  :isEnabled="getNajomcaParameter('isEnabled', 'obchod_meno')"
                  :required="getNajomcaParameter('isRequired', 'obchod_meno')"
                  v-model="najomca.obchod_meno"
                />
              </v-col>
            </v-row>
            <v-row v-if="najomca.id_formy_podn === 2 && najomca.podnika_na_rc">
              <v-col cols="4">
                <text-box
                  label="Meno"
                  :key="najomca.id_formy_podn"
                  v-model="najomca.ine_mena"
                  :isEnabled="getNajomcaParameter('isEnabled', 'ine_mena')"
                  :required="getNajomcaParameter('isRequired', 'ine_mena')"
                />
              </v-col>
              <v-col cols="4">
                <text-box
                  label="Priezvisko"
                  :key="najomca.id_formy_podn"
                  v-model="najomca.obchod_meno"
                  :isEnabled="getNajomcaParameter('isEnabled', 'obchod_meno')"
                  :required="getNajomcaParameter('isRequired', 'obchod_meno')"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="8">
                <text-box
                  label="Registrácia"
                  v-model="najomca.registracia"
                  :isEnabled="getNajomcaParameter('isEnabled', 'registracia')"
                  :required="getNajomcaParameter('isRequired', 'registracia')"
                />
              </v-col>
              <v-col cols="4">
                <date-picker
                  label="Dátum vzniku"
                  v-model="najomca.datum_vzniku"
                  :isEnabled="getNajomcaParameter('isEnabled', 'datum_vzniku')"
                  :required="getNajomcaParameter('isRequired', 'datum_vzniku')"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-checkbox
                  class="dynamic_check_box"
                  label="Je platca DPH"
                  v-model="najomca.je_platcom_dph"
                  @change="
                    v => {
                      if (!v) najomca.ic_dph = null;
                    }
                  "
                  :disabled="!getNajomcaParameter('isEnabled', 'je_platcom_dph')"
                  :false-value="0"
                  :true-value="1"
                />
              </v-col>
              <v-col cols="4">
                <text-box
                  label="IČ DPH"
                  v-model="najomca.ic_dph"
                  @input="
                    v =>
                      (najomca.dic =
                        najomca.ic_dph && najomca.ic_dph.includes('SK')
                          ? najomca.ic_dph.replace('SK', '')
                          : najomca.dic)
                  "
                  :isEnabled="
                    getNajomcaParameter('isEnabled', 'ic_dph') && !!najomca.je_platcom_dph
                  "
                  :required="getNajomcaParameter('isRequired', 'ic_dph')"
                />
              </v-col>
              <v-col cols="4">
                <text-box
                  label="DIČ"
                  v-model="najomca.dic"
                  :isEnabled="getNajomcaParameter('isEnabled', 'dic')"
                  :required="getNajomcaParameter('isRequired', 'dic')"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-autocomplete
                  append-icon="mdi-chevron-down"
                  outlined
                  class="dynamic-input-control"
                  label="Právna forma"
                  :rules="[
                    getNajomcaParameter('isRequired', 'id_pravnej_formy') ? requiredRule : true,
                  ]"
                  v-if="najomca.id_formy_podn === 1"
                  v-model="najomca.id_pravnej_formy"
                  :disabled="!getNajomcaParameter('isEnabled', 'id_pravnej_formy')"
                  :class="{
                    required: getNajomcaParameter('isRequired', 'id_pravnej_formy'),
                  }"
                  :items="pravnaFormaData"
                  item-text="displayMember"
                  item-value="valueMember"
                />
                <v-autocomplete
                  append-icon="mdi-chevron-down"
                  outlined
                  class="dynamic-input-control"
                  label="Koncesia"
                  v-if="najomca.id_formy_podn === 2"
                  v-model="najomca.id_koncesie"
                  :disabled="!getNajomcaParameter('isEnabled', 'id_koncesie')"
                  :class="{
                    required: getNajomcaParameter('isRequired', 'id_koncesie'),
                  }"
                  :rules="[getNajomcaParameter('isRequired', 'id_koncesie') ? requiredRule : true]"
                  :items="koncesiaData"
                  item-text="displayMember"
                  item-value="valueMember"
                />
              </v-col>
              <v-col cols="4">
                <text-box
                  ref="iban"
                  label="IBAN"
                  v-model="najomca.iban"
                  @input="
                    v => 
                      checkCorrectnessIban(v)
                  "
                  :isEnabled="getNajomcaParameter('isEnabled', 'iban')"
                  :required="getNajomcaParameter('isRequired', 'iban')"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="8">
                <text-box
                  label="Charakteristika predmetu podnikania"
                  v-model="najomca.oblast_podn_nace_nazov"
                  :isEnabled="getNajomcaParameter('isEnabled', 'oblast_podn_nace_nazov')"
                  :required="getNajomcaParameter('isRequired', 'oblast_podn_nace_nazov')"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <text-box
                  label="Počet zamestnancov"
                  v-model="najomca.pocet_zamestnancov"
                  :isEnabled="getNajomcaParameter('isEnabled', 'pocet_zamestnancov')"
                  :required="getNajomcaParameter('isRequired', 'pocet_zamestnancov')"
                />
              </v-col>
              <v-col cols="4">
                <v-autocomplete
                  append-icon="mdi-chevron-down"
                  outlined
                  class="dynamic-input-control"
                  label="Zdroj finančných prostriedkov"
                  v-model="najomca.id_zdroja_fin_prostriedkov"
                  :rules="[getNajomcaParameter('isRequired', 'id_zdroja_fin_prostriedkov') ? requiredRule : true]"
                  :disabled="!getNajomcaParameter('isEnabled', 'id_zdroja_fin_prostriedkov')"
                  :class="{
                    required: getNajomcaParameter('isRequired', 'id_zdroja_fin_prostriedkov'),
                  }"
                  :items="zdrojFinProstredkovData"
                  item-text="displayMember"
                  item-value="valueMember"
                />
              </v-col>
            </v-row>
              
          </div>

          <!-- ####### -->
          <!-- FON      -->
          <!-- ####### -->
          <div class="mt-8" v-if="najomca.id_formy_podn === 3">
            <v-row>
              <v-col cols="4">
                <text-box
                  label="Meno"
                  v-model="najomca.ine_mena"
                  :isEnabled="getNajomcaParameter('isEnabled', 'ine_mena')"
                  :required="getNajomcaParameter('isRequired', 'ine_mena')"
                />
              </v-col>
              <v-col cols="4">
                <text-box
                  label="Priezvisko"
                  v-model="najomca.obchod_meno"
                  :isEnabled="getNajomcaParameter('isEnabled', 'obchod_meno')"
                  :required="getNajomcaParameter('isRequired', 'obchod_meno')"
                />
              </v-col>
              <!-- <v-col cols="4">
                              <text-box
                                label="Rodné priezvisko"
                                v-model="najomca.rodne_priezvisko"
                                :isEnabled="getNajomcaParameter('isEnabled', 'rodne_priezvisko')"
                                :required="getNajomcaParameter('isRequired', 'rodne_priezvisko')"
                              />
                            </v-col> -->
            </v-row>
            <v-row>
              <v-col cols="4">
                <text-box
                  ref="iban"
                  label="IBAN"
                  v-model="najomca.iban"
                  @input="
                    v => 
                      checkCorrectnessIban(v)
                  "
                  :isEnabled="getNajomcaParameter('isEnabled', 'iban')"
                  :required="getNajomcaParameter('isRequired', 'iban')"
                />
              </v-col>
            </v-row>
            <!-- <v-row>
                          <v-col cols="4">
                            <v-autocomplete
                              append-icon="mdi-chevron-down"
                              outlined
                              class="dynamic-input-control"
                              label="Titul pred menom"
                              v-model="najomca.titul1"
                              :rules="[getNajomcaParameter('isRequired', 'titul1') ? requiredRule : true]"
                              :disabled="!getNajomcaParameter('isEnabled', 'titul1')"
                              :class="{
                                required: getNajomcaParameter('isRequired', 'titul1'),
                              }"
                              :items="titul1Data"
                              item-text="displayMember"
                              item-value="valueMember"
                            />
                          </v-col>
                          <v-col cols="4">
                            <v-autocomplete
                              append-icon="mdi-chevron-down"
                              outlined
                              class="dynamic-input-control"
                              label="Titul za menom"
                              v-model="najomca.titul2"
                              :rules="[getNajomcaParameter('isRequired', 'titul2') ? requiredRule : true]"
                              :disabled="!getNajomcaParameter('isEnabled', 'titul2')"
                              :class="{
                                required: getNajomcaParameter('isRequired', 'titul2'),
                              }"
                              :items="titul2Data"
                              item-text="displayMember"
                              item-value="valueMember"
                            />
                          </v-col>
                        </v-row> -->
          </div>
        </v-card>

        <!-- ############################################################ -->
        <!-- REGISTRACNA ADRESA -->
        <!-- ############################################################ -->

        <v-card
          class="mt-6 card"
          v-if="
            najomca.id_formy_podn === 1 || (najomca.id_formy_podn === 2 && !najomca.podnika_na_rc)
          "
        >
          <h2 class="mb-6">Sídlo firmy</h2>
          <v-row>
            <v-col cols="4">
              <text-box
                label="Ulica"
                v-model="najomca.ulica_reg"
                :isEnabled="getNajomcaParameter('isEnabled', 'ulica_reg')"
                :required="getNajomcaParameter('isRequired', 'ulica_reg')"
              />
            </v-col>
            <v-col cols="4">
              <text-box
                label="Číslo domu"
                v-model="najomca.cislo_domu_reg"
                :isEnabled="getNajomcaParameter('isEnabled', 'cislo_domu_reg')"
                :required="getNajomcaParameter('isRequired', 'cislo_domu_reg')"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <text-box
                label="Mesto/obec"
                v-model="najomca.mesto_reg"
                :isEnabled="getNajomcaParameter('isEnabled', 'mesto_reg')"
                :required="getNajomcaParameter('isRequired', 'mesto_reg')"
              />
            </v-col>
            <v-col cols="4">
              <text-box
                label="PSČ"
                v-model="najomca.psc_reg"
                :isEnabled="getNajomcaParameter('isEnabled', 'psc_reg')"
                :required="getNajomcaParameter('isRequired', 'psc_reg')"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8">
              <v-autocomplete
                append-icon="mdi-chevron-down"
                outlined
                class="dynamic-input-control"
                label="Štát"
                v-model="najomca.stat_reg"
                :rules="[getNajomcaParameter('isRequired', 'stat_reg') ? requiredRule : true]"
                :disabled="!getNajomcaParameter('isEnabled', 'stat_reg')"
                :class="{
                  required: getNajomcaParameter('isRequired', 'stat_reg'),
                }"
                :items="statyData"
                item-text="displayMember"
                item-value="valueMember"
              />
            </v-col>
          </v-row>
        </v-card>

        <!-- ############################################################ -->
        <!-- KORESPONDENCNA ADRESA -->
        <!-- ############################################################ -->

        <v-card
          class="mt-6 card"
          v-if="
            najomca.adresa_kor_visible &&
            (najomca.id_formy_podn === 1 || (najomca.id_formy_podn === 2 && !najomca.podnika_na_rc))
          "
        >
          <div class="d-flex">
            <h2>Korešpondenčná adresa</h2>
            <v-btn @click="showKor = !showKor" class="btn-secondary ml-auto" icon>
              <v-icon :class="{ 'rotate-180': showKor }">mdi-chevron-down</v-icon>
            </v-btn>
          </div>
          <v-expand-transition>
            <div v-show="showKor" class="mt-6">
              <v-row>
                <v-col cols="4">
                  <text-box
                    label="Ulica"
                    v-model="najomca.ulica_kor"
                    :isEnabled="getNajomcaParameter('isEnabled', 'ulica_kor')"
                    :required="getNajomcaParameter('isRequired', 'ulica_kor')"
                  />
                </v-col>
                <v-col cols="4">
                  <text-box
                    label="Číslo domu"
                    v-model="najomca.cislo_domu_kor"
                    :isEnabled="getNajomcaParameter('isEnabled', 'cislo_domu_kor')"
                    :required="getNajomcaParameter('isRequired', 'cislo_domu_kor')"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <text-box
                    label="Mesto/obec"
                    v-model="najomca.mesto_kor"
                    :isEnabled="getNajomcaParameter('isEnabled', 'mesto_kor')"
                    :required="getNajomcaParameter('isRequired', 'mesto_kor')"
                  />
                </v-col>
                <v-col cols="4">
                  <text-box
                    label="PSČ"
                    v-model="najomca.psc_kor"
                    :isEnabled="getNajomcaParameter('isEnabled', 'psc_kor')"
                    :required="getNajomcaParameter('isRequired', 'psc_kor')"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="8">
                  <v-autocomplete
                    append-icon="mdi-chevron-down"
                    outlined
                    class="dynamic-input-control"
                    label="Štát"
                    v-model="najomca.stat_kor"
                    :rules="[getNajomcaParameter('isRequired', 'stat_kor') ? requiredRule : true]"
                    :disabled="!getNajomcaParameter('isEnabled', 'stat_kor')"
                    :class="{
                      required: getNajomcaParameter('isRequired', 'stat_kor'),
                    }"
                    :items="statyData"
                    item-text="displayMember"
                    item-value="valueMember"
                  />
                </v-col>
              </v-row>
            </div>
          </v-expand-transition>
        </v-card>
      </v-form>

      <!-- ############################################################ -->
      <!-- KONTAKTNE OSOBY -->
      <!-- ############################################################ -->

      <v-card
        class="mt-6 card" 
        v-for="zas in zastupcovia"
        :key="zas.id_zastupcu"
        :id="'zastupca' + zas.id_zastupcu"
      >
        <div class="d-flex">
          <h2 class="mr-15px">
            {{ zas.id_zastupcu > 0 ? zas.meno + ' ' + zas.priezvisko : 'Nová kontaktná osoba' }}
          </h2>
          <template v-if="zas.id_zastupcu > 0">
            <span class="mr-15px f14 my-auto" v-if="zas.cislo_dokladu">
              <v-icon size="18" class="mr-5px gs100">mdi-card-account-details-outline</v-icon
              >{{ zas.cislo_dokladu }}
            </span>
            <span class="f14 my-auto" v-if="getAdresa(zas)">
              <v-icon size="18" class="mr-5px gs100">mdi-home-city-outline</v-icon
              >{{ getAdresa(zas) }}
            </span>
          </template>

          <v-btn
            @click="removeZastupca(zas)"
            class="btn-terciary ml-auto mr-3"
            icon
            v-if="zas.id_zastupcu < 0"
          >
            <v-icon size="20">mdi-trash-can-outline</v-icon>
          </v-btn>
          <v-btn
            @click="openCloseZastupca(zas)"
            class="btn-secondary"
            :class="{ 'ml-auto': zas.id_zastupcu > 0 }"
            icon
          >
            <v-icon :class="{ 'rotate-180': zas.show }">mdi-chevron-down</v-icon>
          </v-btn>
        </div>

        <v-expand-transition>
          <div v-show="zas.show">
            <v-form :ref="'form_manual_' + zas.id_zastupcu" autocomplete="off">
              <v-row class="mt-6">
                <v-col xl="4" lg="4" md="4" v-if="najomca.id_formy_podn == 1">
                  <v-autocomplete
                    append-icon="mdi-chevron-down"
                    outlined
                    class="dynamic-input-control"
                    label="Funkcia"
                    :rules="[
                      getZastupcaParameter('isRequired', 'id_funkcie', zas.id_zastupcu)
                        ? requiredRule
                        : true,
                    ]"
                    :items="funkcieData"
                    item-text="displayMember"
                    item-value="valueMember"
                    v-model="zas.id_funkcie"
                    :class="{
                      required: getZastupcaParameter('isRequired', 'id_funkcie', zas.id_zastupcu),
                    }"
                    :disabled="!getZastupcaParameter('isEnabled', 'id_funkcie', zas.id_zastupcu)"
                  />
                </v-col>
                <v-col xl="4" lg="4" md="4">
                  <text-box
                    label="Email"
                    placeholder="@"
                    v-model="zas.email"
                    :isEnabled="getZastupcaParameter('isEnabled', 'email', zas.id_zastupcu)"
                    :required="getZastupcaParameter('isRequired', 'email', zas.id_zastupcu)"
                    @change="()=> checkProfilVKZ(zas)"
                    :rules="[
                      v =>
                        emailRegex.test(v) ||
                        !zas.email ||
                        !v ||
                        'Nesprávny formát e-mailovej adresy',
                    ]"
                  >
                  </text-box>
                </v-col>
                <v-col xl="4" lg="4" md="4">
                  <text-box
                    ref="telefon"
                    label="Telefón"
                    placeholder="+421"
                    v-model="zas.mobil"
                    :rules="[telefonneCisloRule]"
                    :isEnabled="getZastupcaParameter('isEnabled', 'mobil', zas.id_zastupcu)"
                    :required="getZastupcaParameter('isRequired', 'mobil', zas.id_zastupcu)"
                    textOnFocus="+421"
                    :removeCharacters="/[^+\d]/g"
                    :isPhoneNumber="true"
                  ></text-box>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  xl="3"
                  lg="3"
                  md="3"
                  v-if="najomca.id_formy_podn == 1 || najomca.id_formy_podn == 2"
                  style="height: 70px"
                >
                  <v-checkbox
                    class="dynamic_check_box"
                    label="Konečný užívateľ výhod"
                    v-model="zas.konecny_uzivatel_vyhod"
                    :disabled="
                      !getZastupcaParameter('isEnabled', 'konecny_uzivatel_vyhod', zas.id_zastupcu)
                    "
                    :false-value="0"
                    :true-value="1"
                  ></v-checkbox>
                </v-col>
                <v-col
                  xl="3"
                  lg="3"
                  md="3"
                  v-if="najomca.id_formy_podn == 1 || najomca.id_formy_podn == 2"
                >
                  <v-checkbox
                    class="dynamic_check_box"
                    label="Štatutárny zástupca"
                    v-model="zas.je_konatel"
                    :disabled="!getZastupcaParameter('isEnabled', 'je_konatel', zas.id_zastupcu)"
                    :false-value="0"
                    :true-value="1"
                  ></v-checkbox>
                </v-col>
                <v-col xl="3" lg="3" md="3">
                  <v-checkbox
                    class="dynamic_check_box"
                    label="Zahraničná osoba"
                    v-model="zas.zahranicna_osoba"
                    :disabled="
                      !getZastupcaParameter('isEnabled', 'zahranicna_osoba', zas.id_zastupcu)
                    "
                    :false-value="0"
                    :true-value="1"
                    @change="val => nastavObcianstvo(val, zas)"
                  ></v-checkbox>
                </v-col>
                <v-col
                  xl="3"
                  lg="3"
                  md="3"
                >
                  <v-checkbox
                    class="dynamic_check_box"
                    label="Profil v KZ"
                    v-model="zas.ma_profil_kz"
                    :disabled="!getZastupcaParameter('isEnabled', 'ma_profil_kz', zas.id_zastupcu)"
                    :false-value="0"
                    :true-value="1"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row class="mb-8" style="align-items: center;">
                <v-col class="col-auto">
                  <v-btn
                    class="btn-primary"
                    @click="setIdentityTB(zas)"
                    :disabled="sendingRequest || !zas.email || idVytazenia != null"
                  >
                    Odoslať Identity TB
                  </v-btn>
                  <!-- <v-btn
                    class="btn-primary"
                    @click="
                      sendOpRequest(
                        zas.email,
                        zas.mobil,
                        zas.meno + ' ' + zas.priezvisko,
                        zas.zahranicna_osoba
                      )
                    "
                    :disabled="
                      zas.nahratOpDisabled || !zas.email || !zas.mobil || zas.sendingRequest
                    "
                  >
                    Nahrať {{ zas.zahranicna_osoba ? 'doklad' : 'OP' }} nájomcom
                  </v-btn> -->
                  <v-btn
                    class="btn-primary ml-5"
                    @click="confirmAndSendOp(zas)"
                    :disabled="!zas.email || !zas.mobil || sendingRequest || idVytazenia != null"
                  >
                    Nahrať {{ zas.zahranicnaOsoba ? 'doklad' : 'OP' }}
                  </v-btn>
                  <v-btn
                      class="btn-primary ml-5"
                      @click="confirmAndOpenSendOpMobilDialog(zas)"
                      :disabled="!zas.email || !zas.mobil || sendingRequest || idVytazenia != null"
                    >
                      Odfotiť {{ zas.zahranicnaOsoba ? 'doklad' : 'OP' }} cez MT
                    </v-btn>
                  <!-- <v-dialog
                    v-model="zas.openUploadDialog"
                    overlay-color="#000"
                    overlay-opacity="0.66"
                    persistent
                    max-width="500"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="btn-secondary ml-5"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="zas.nahratOpDisabled"
                      >
                        Nahrať {{ zas.zahranicna_osoba ? 'doklad' : 'OP' }}
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title class="d-flex justify-space-between">
                        Nahrajte prosím {{ zas.zahranicna_osoba ? 'doklad' : 'občiansky preukaz' }}
                        <v-btn icon @click="zas.openUploadDialog = false">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-card-title>
                      <v-card-text>
                        <upload-area
                          :ref="'refuploadarea' + zas.id_zastupcu"
                          @uploaded="() => (zas.opUploaded = true)"
                        ></upload-area>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          class="btn-secondary ml-5"
                          @click="zas.openUploadDialog = false"
                          :disabled="zas.uloadujemData"
                        >
                          Späť
                        </v-btn>
                        <v-btn
                          class="btn-primary"
                          @click="dmsSave(zas)"
                          :disabled="zas.uloadujemData"
                        >
                          <v-icon left> mdi-upload-outline </v-icon>
                          Nahrať
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog> -->
                  <v-btn
                    class="btn-secondary ml-5"
                    v-on:click="zas.zadatOpManualne = !zas.zadatOpManualne"
                  >
                    Zadať {{ zas.zahranicna_osoba ? 'doklad' : 'OP' }} manuálne
                  </v-btn>
                </v-col>
                <v-col class="col-auto">
                  <v-checkbox
                  class="dynamic_check_box"
                  label="Fyzické overenie"
                  v-model="zas.fyzicky_overeny"
                  :disabled="!getZastupcaParameter('isEnabled', 'fyzicky_overeny',zas.id_zastupcu)"
                  :false-value="0"
                  :true-value="1"
                  @change="val => nastavFyzickeOverenie(val, zas)"
                />
                </v-col>
              </v-row>

              <!-- ########### -->
              <!-- Manualne OP -->
              <!-- ########### -->

              <div v-show="zas.zadatOpManualne">
                <v-row class="mt-8">
                  <v-col xl="4" lg="4" md="4">
                    <v-autocomplete
                      append-icon="mdi-chevron-down"
                      outlined
                      class="dynamic-input-control"
                      label="Titul"
                      :items="titul1Data"
                      item-text="displayMember"
                      item-value="valueMember"
                      v-model="zas.titul_1"
                      :rules="[
                        getZastupcaParameter('isRequired', 'titul_1', zas.id_zastupcu)
                          ? requiredRule
                          : true,
                      ]"
                      :class="{
                        required: getZastupcaParameter('isRequired', 'titul_1', zas.id_zastupcu),
                      }"
                      :disabled="!getZastupcaParameter('isEnabled', 'titul_1', zas.id_zastupcu)"
                    />
                  </v-col>
                  <v-col xl="4" lg="4" md="4">
                    <v-autocomplete
                      append-icon="mdi-chevron-down"
                      outlined
                      class="dynamic-input-control"
                      label="Pohlavie"
                      :rules="[
                        getZastupcaParameter('isRequired', 'pohlavie', zas.id_zastupcu)
                          ? requiredRule
                          : true,
                      ]"
                      :items="pohlaviaData"
                      item-text="displayMember"
                      item-value="valueMember"
                      v-model="zas.pohlavie"
                      :class="{
                        required: getZastupcaParameter('isRequired', 'pohlavie', zas.id_zastupcu),
                      }"
                      :disabled="!getZastupcaParameter('isEnabled', 'pohlavie', zas.id_zastupcu)"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col xl="4" lg="4" md="4">
                    <text-box
                      label="Meno"
                      placeholder="Meno kontaktnej osoby"
                      v-model="zas.meno"
                      :isEnabled="getZastupcaParameter('isEnabled', 'meno', zas.id_zastupcu)"
                      :required="getZastupcaParameter('isRequired', 'meno', zas.id_zastupcu)"
                    ></text-box>
                  </v-col>
                  <v-col xl="4" lg="4" md="4">
                    <text-box
                      label="Priezvisko"
                      placeholder="Priezvisko kontaktnej osoby"
                      v-model="zas.priezvisko"
                      :isEnabled="getZastupcaParameter('isEnabled', 'priezvisko', zas.id_zastupcu)"
                      :required="getZastupcaParameter('isRequired', 'priezvisko', zas.id_zastupcu)"
                    ></text-box>
                  </v-col>
                  <v-col xl="4" lg="4" md="4">
                    <DatePicker
                      label="Dátum narodenia"
                      placeholder="DD/MM/YYYY"
                      v-model="zas.datum_narodenia"
                      :isEnabled="
                        getZastupcaParameter('isEnabled', 'datum_narodenia', zas.id_zastupcu)
                      "
                      :required="
                        getZastupcaParameter('isRequired', 'datum_narodenia', zas.id_zastupcu)
                      "
                    ></DatePicker>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col xl="4" lg="4" md="4">
                    <v-autocomplete
                      append-icon="mdi-chevron-down"
                      outlined
                      class="dynamic-input-control"
                      :rules="[
                        getZastupcaParameter('isRequired', 'id_krajiny_dokladu', zas.id_zastupcu)
                          ? requiredRule
                          : true,
                        v => statnaPrislusnostRule(v, zas),
                      ]"
                      :label="zas.zahranicna_osoba ? 'Štátna príslušnosť' : 'Štátne občianstvo'"
                      :items="statyData"
                      item-text="displayMember"
                      item-value="valueMember"
                      v-model="zas.id_krajiny_dokladu"
                      :class="{
                        required: getZastupcaParameter(
                          'isRequired',
                          'id_krajiny_dokladu',
                          zas.id_zastupcu
                        ),
                      }"
                      :disabled="
                        !getZastupcaParameter('isEnabled', 'id_krajiny_dokladu', zas.id_zastupcu)
                      "
                    />
                  </v-col>
                  <v-col xl="4" lg="4" md="4">
                    <text-box
                      :key="zas.rc"
                      :rodneCislo="!zas.zahranicna_osoba"
                      :staticLabel="zas.zahranicna_osoba ? 'Identifikačné číslo' : 'Rodné číslo'"
                      placeholder="rdč. bez /"
                      v-model="zas.rc"
                      :isEnabled="getZastupcaParameter('isEnabled', 'rc', zas.id_zastupcu)"
                      :required="getZastupcaParameter('isRequired', 'rc', zas.id_zastupcu)"
                      @input="v => onRodneCisloInput(v, zas)"
                    ></text-box>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col xl="4" lg="4" md="4">
                    <text-box
                      :staticLabel="zas.zahranicna_osoba ? 'Číslo dokladu' : 'Číslo OP'"
                      placeholder="XX123456"
                      v-model="zas.cislo_dokladu"
                      :isEnabled="
                        getZastupcaParameter('isEnabled', 'cislo_dokladu', zas.id_zastupcu)
                      "
                      :required="
                        getZastupcaParameter('isRequired', 'cislo_dokladu', zas.id_zastupcu)
                      "
                    ></text-box>
                  </v-col>
                  <v-col xl="4" lg="4" md="4">
                    <DatePicker
                      label="Dátum vydania"
                      placeholder="DD/MM/YYYY"
                      v-model="zas.platnost_od"
                      @inputChanged="v => updateDatumPlatnosti(v, zas)"
                      :isEnabled="getZastupcaParameter('isEnabled', 'platnost_od', zas.id_zastupcu)"
                      :required="getZastupcaParameter('isRequired', 'platnost_od', zas.id_zastupcu)"
                    />
                  </v-col>
                  <v-col xl="4" lg="4" md="4">
                    <DatePicker
                      :staticLabel="zas.zahranicna_osoba ? 'Platnosť do' : 'Dátum platnosti'"
                      placeholder="DD/MM/YYYY"
                      v-model="zas.platnost_do"
                      :isEnabled="getZastupcaParameter('isEnabled', 'platnost_do', zas.id_zastupcu)"
                      :required="getZastupcaParameter('isRequired', 'platnost_do', zas.id_zastupcu)"
                    ></DatePicker>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col xl="4" lg="4" md="4">
                    <v-combobox
                      label="Mesto/obec"
                      append-icon="mdi-chevron-down"
                      outlined
                      class="dynamic-input-control"
                      v-model="zas.mesto"
                      :items="zas.mestoSearchData"
                      :loading="zas.mestoSearchLoading.value"
                      no-filter
                      clearable
                      item-text="displayMember"
                      item-value="valueMember"
                      return-object
                      @change="cityOnChange($event, zas)"
                      @update:search-input="searchCity($event, zas, 3)"
                      :disabled="!getZastupcaParameter('isEnabled', 'mesto', zas.id_zastupcu)"
                      :class="{
                        required: getZastupcaParameter('isRequired', 'mesto', zas.id_zastupcu),
                      }"
                      :rules="[
                        getZastupcaParameter('isRequired', 'mesto', zas.id_zastupcu)
                          ? requiredRule
                          : true,
                      ]"
                    />
                  </v-col>
                  <v-col xl="4" lg="4" md="4">
                    <v-combobox
                      label="Ulica"
                      append-icon="mdi-chevron-down"
                      outlined
                      class="dynamic-input-control"
                      v-model="zas.ulica"
                      :items="zas.ulicaSearchData"
                      :loading="zas.ulicaSearchLoading.value"
                      no-filter
                      item-text="displayMember"
                      item-value="valueMember"
                      clearable
                      return-object
                      @change="streetOnChange($event, zas)"
                      @update:search-input="searchStreets($event, zas, 3)"
                      :disabled="!getZastupcaParameter('isEnabled', 'ulica', zas.id_zastupcu)"
                      :class="{
                        required: getZastupcaParameter('isRequired', 'ulica', zas.id_zastupcu),
                      }"
                      :rules="[
                        getZastupcaParameter('isRequired', 'ulica', zas.id_zastupcu)
                          ? requiredRule
                          : true,
                      ]"
                    />
                  </v-col>
                  <v-col xl="4" lg="4" md="4">
                    <v-combobox
                      label="Číslo domu"
                      append-icon="mdi-chevron-down"
                      outlined
                      class="dynamic-input-control"
                      v-model="zas.cislo_domu"
                      :items="zas.cislo_domuSearchData"
                      :loading="zas.cislo_domuSearchLoading.value"
                      no-filter
                      clearable
                      item-text="displayMember"
                      item-value="valueMember"
                      return-object
                      @change="addressOnChange($event, zas)"
                      @update:search-input="searchAddresses($event, zas, 0)"
                      :disabled="!getZastupcaParameter('isEnabled', 'cislo_domu', zas.id_zastupcu)"
                      :class="{
                        required: getZastupcaParameter('isRequired', 'cislo_domu', zas.id_zastupcu),
                      }"
                      :rules="[
                        getZastupcaParameter('isRequired', 'cislo_domu', zas.id_zastupcu)
                          ? requiredRule
                          : true,
                      ]"
                    />
                  </v-col>
                  <v-col xl="4" lg="4" md="4">
                    <v-combobox
                      label="PSČ"
                      append-icon="mdi-chevron-down"
                      outlined
                      class="dynamic-input-control"
                      v-model="zas.psc"
                      :items="zas.pscSearchData"
                      :loading="zas.pscSearchLoading.value"
                      no-filter
                      clearable
                      item-text="displayMember"
                      item-value="valueMember"
                      return-object
                      :rules="[
                        v => {
                          if (zas.obcianstvo !== 1) return true;
                          if (!v) return true;
                          if (!/^[0-9]*$/.exec(v)) return 'PSČ smie obsahovať iba čísla';
                          if (v.length != 5) return 'Nesprávne PSČ';
                          return true;
                        },
                        getZastupcaParameter('isRequired', 'psc', zas.id_zastupcu)
                          ? requiredRule
                          : true,
                      ]"
                      @update:search-input="searchZIP($event, zas)"
                      :disabled="!getZastupcaParameter('isEnabled', 'psc', zas.id_zastupcu)"
                      :class="{
                        required: getZastupcaParameter('isRequired', 'psc', zas.id_zastupcu),
                      }"
                    />
                  </v-col>
                </v-row>
              </div>
            </v-form>

            <!-- ########### -->
            <!-- OP karticka -->
            <!-- ########### -->
            <v-form :ref="'form_op_' + zas.id_zastupcu" autocomplete="off">
              <div v-show="!zas.zadatOpManualne">
                <div class="d-flex op-cards">
                  <!-- ######################## -->
                  <!-- OP karticka ZADNA strana -->
                  <!-- ######################## -->
                  <v-card class="op-back pb-0">
                    <v-row>
                      <v-col cols="6">
                        <div :class="{ readonly: zas.readonly }">
                          <v-combobox
                            label="Mesto/obec"
                            :readonly="zas.readonly"
                            :class="{
                              readonly: zas.readonly,
                              required: getZastupcaParameter(
                                'isRequired',
                                'mesto',
                                zas.id_zastupcu
                              ),
                            }"
                            :rules="[
                              getZastupcaParameter('isRequired', 'mesto', zas.id_zastupcu)
                                ? requiredRule
                                : true,
                            ]"
                            append-icon="mdi-chevron-down"
                            outlined
                            class="dynamic-input-control naked"
                            v-model="zas.mesto"
                            :items="zas.mestoSearchData"
                            :loading="zas.mestoSearchLoading.value"
                            no-filter
                            clearable
                            item-text="displayMember"
                            item-value="valueMember"
                            return-object
                            @change="cityOnChange($event, zas)"
                            @update:search-input="searchCity($event, zas, 3)"
                            :disabled="!getZastupcaParameter('isEnabled', 'mesto', zas.id_zastupcu)"
                          />
                        </div>
                      </v-col>
                      <v-col cols="6"></v-col>
                      <v-col cols="6">
                        <div :class="{ readonly: zas.readonly }">
                          <v-combobox
                            label="Ulica"
                            append-icon="mdi-chevron-down"
                            outlined
                            :readonly="zas.readonly"
                            :class="{
                              readonly: zas.readonly,
                              required: getZastupcaParameter(
                                'isRequired',
                                'ulica',
                                zas.id_zastupcu
                              ),
                            }"
                            class="dynamic-input-control naked"
                            v-model="zas.ulica"
                            :items="zas.ulicaSearchData"
                            :loading="zas.ulicaSearchLoading.value"
                            no-filter
                            item-text="displayMember"
                            item-value="valueMember"
                            clearable
                            return-object
                            @change="streetOnChange($event, zas)"
                            @update:search-input="searchStreets($event, zas, 3)"
                            :disabled="!getZastupcaParameter('isEnabled', 'ulica', zas.id_zastupcu)"
                            :rules="[
                              getZastupcaParameter('isRequired', 'ulica', zas.id_zastupcu)
                                ? requiredRule
                                : true,
                            ]"
                          />
                        </div>
                      </v-col>
                      <v-col cols="6">
                        <div :class="{ readonly: zas.readonly }">
                          <v-combobox
                            label="Číslo domu"
                            :readonly="zas.readonly"
                            :class="{
                              readonly: zas.readonly,
                              required: getZastupcaParameter(
                                'isRequired',
                                'cislo_domu',
                                zas.id_zastupcu
                              ),
                            }"
                            append-icon="mdi-chevron-down"
                            outlined
                            class="dynamic-input-control naked"
                            v-model="zas.cislo_domu"
                            :items="zas.cislo_domuSearchData"
                            :loading="zas.cislo_domuSearchLoading.value"
                            no-filter
                            clearable
                            item-text="displayMember"
                            item-value="valueMember"
                            return-object
                            @change="addressOnChange($event, zas)"
                            @update:search-input="searchAddresses($event, zas, 0)"
                            :disabled="
                              !getZastupcaParameter('isEnabled', 'cislo_domu', zas.id_zastupcu)
                            "
                            :rules="[
                              getZastupcaParameter('isRequired', 'cislo_domu', zas.id_zastupcu)
                                ? requiredRule
                                : true,
                            ]"
                          />
                        </div>
                      </v-col>
                      <v-col cols="6">
                        <div :class="{ readonly: zas.readonly }">
                          <v-combobox
                            label="PSČ"
                            :readonly="zas.readonly"
                            :class="{
                              readonly: zas.readonly,
                              required: getZastupcaParameter('isRequired', 'psc', zas.id_zastupcu),
                            }"
                            append-icon="mdi-chevron-down"
                            outlined
                            class="dynamic-input-control naked"
                            v-model="zas.psc"
                            :items="zas.pscSearchData"
                            :loading="zas.pscSearchLoading.value"
                            no-filter
                            clearable
                            item-text="displayMember"
                            item-value="valueMember"
                            return-object
                            :rules="[
                              v => {
                                if (zas.obcianstvo !== 1) return true;
                                if (!v) return true;
                                if (!/^[0-9]*$/.exec(v)) return 'PSČ smie obsahovať iba čísla';
                                if (v.length != 5) return 'Nesprávne PSČ';

                                return true;
                              },
                              getZastupcaParameter('isRequired', 'psc', zas.id_zastupcu)
                                ? requiredRule
                                : true,
                            ]"
                            @update:search-input="searchZIP($event, zas)"
                            :disabled="!getZastupcaParameter('isEnabled', 'psc', zas.id_zastupcu)"
                          />
                        </div>
                      </v-col>
                      <v-col cols="6"></v-col>
                      <v-col cols="6">
                        <text-box
                          label="Miesto narodenia"
                          :readonly="zas.readonly"
                          :class="{ readonly: zas.readonly }"
                          v-model="zas.miesto_narodenia"
                          :isEnabled="
                            getZastupcaParameter('isEnabled', 'miesto_narodenia', zas.id_zastupcu)
                          "
                          :required="
                            getZastupcaParameter('isRequired', 'miesto_narodenia', zas.id_zastupcu)
                          "
                          naked
                        ></text-box>
                      </v-col>
                      <v-col cols="6">
                        <text-box
                          v-if="!zas.zahranicna_osoba"
                          label="Rodné priezvisko"
                          :key="zas.zahranicna_osoba"
                          :readonly="zas.readonly"
                          :class="{ readonly: zas.readonly }"
                          v-model="zas.rodne_priezvisko"
                          :isEnabled="
                            getZastupcaParameter('isEnabled', 'rodne_priezvisko', zas.id_zastupcu)
                          "
                          :required="
                            getZastupcaParameter('isRequired', 'rodne_priezvisko', zas.id_zastupcu)
                          "
                          naked
                        ></text-box>
                        <text-box
                          v-else
                          :key="zas.zahranicna_osoba + 'x'"
                          naked
                          class="readonly"
                          readonly
                        ></text-box>
                      </v-col>
                      <v-col cols="6">
                        <text-box
                          label="Osobité záznamy"
                          :readonly="zas.readonly"
                          :class="{ readonly: zas.readonly }"
                          v-model="zas.osobitne_zaznamy"
                          :isEnabled="
                            getZastupcaParameter('isEnabled', 'osobitne_zaznamy', zas.id_zastupcu)
                          "
                          :required="
                            getZastupcaParameter('isRequired', 'osobitne_zaznamy', zas.id_zastupcu)
                          "
                          naked
                        ></text-box>
                      </v-col>
                    </v-row>
                    <v-btn
                      class="btn-icon btn-op-edit"
                      :class="{
                        'btn-terciary': zas.readonly,
                        'btn-secondary': !zas.readonly,
                      }"
                      @click="zas.readonly = !zas.readonly"
                    >
                      <v-icon>
                        {{ zas.readonly ? 'mdi-pencil-outline' : 'mdi-check' }}
                      </v-icon>
                    </v-btn>
                  </v-card>

                  <!-- ######################## -->
                  <!-- OP karticka PREDNA strana -->
                  <!-- ######################## -->
                  <v-card class="op order-first pb-0 px-25px">
                    <div class="d-flex">
                      <v-img
                        class="mt-30px"
                        :width="123"
                        :height="163"
                        :src="
                          require(`../assets/img/${
                            zas.pohlavie === 2 ? 'op_female.png' : 'op_male.png'
                          }`)
                        "
                      ></v-img>
                      <div class="pl-34px">
                        <v-row>
                          <v-col cols="7">
                            <text-box
                              label="Priezvisko"
                              :readonly="zas.readonly"
                              :class="{ readonly: zas.readonly }"
                              naked
                              v-model="zas.priezvisko"
                              :isEnabled="
                                getZastupcaParameter('isEnabled', 'priezvisko', zas.id_zastupcu)
                              "
                              :required="
                                getZastupcaParameter('isRequired', 'priezvisko', zas.id_zastupcu)
                              "
                            ></text-box>
                          </v-col>
                          <v-col cols="5">
                            <date-picker
                              label="Dátum narodenia"
                              :readonly="zas.readonly"
                              :class="{ readonly: zas.readonly }"
                              no-icon
                              text-only
                              naked
                              v-model="zas.datum_narodenia"
                              :isEnabled="
                                getZastupcaParameter(
                                  'isEnabled',
                                  'datum_narodenia',
                                  zas.id_zastupcu
                                )
                              "
                              :required="
                                getZastupcaParameter(
                                  'isRequired',
                                  'datum_narodenia',
                                  zas.id_zastupcu
                                )
                              "
                            />
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="7">
                            <text-box
                              label="Meno"
                              :readonly="zas.readonly"
                              :class="{ readonly: zas.readonly }"
                              naked
                              v-model="zas.meno"
                              :isEnabled="
                                getZastupcaParameter('isEnabled', 'meno', zas.id_zastupcu)
                              "
                              :required="
                                getZastupcaParameter('isRequired', 'meno', zas.id_zastupcu)
                              "
                            ></text-box>
                          </v-col>
                          <v-col cols="5">
                            <text-box
                              :staticLabel="
                                zas.zahranicna_osoba ? 'Identifikačné číslo' : 'Rodné číslo'
                              "
                              :key="zas.rc"
                              :rodneCislo="!zas.zahranicna_osoba"
                              :readonly="zas.readonly"
                              :class="{ readonly: zas.readonly }"
                              @input="v => onRodneCisloInput(v, zas)"
                              naked
                              v-model="zas.rc"
                              :isEnabled="getZastupcaParameter('isEnabled', 'rc', zas.id_zastupcu)"
                              :required="getZastupcaParameter('isRequired', 'rc', zas.id_zastupcu)"
                            ></text-box>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" class="pr-0">
                            <div :class="{ readonly: zas.readonly }">
                              <v-autocomplete
                                append-icon="mdi-chevron-down"
                                outlined
                                class="dynamic-input-control naked"
                                :label="
                                  zas.zahranicna_osoba ? 'Štátna príslušnosť' : 'Štátne občianstvo'
                                "
                                :rules="[
                                  getZastupcaParameter(
                                    'isRequired',
                                    'id_krajiny_dokladu',
                                    zas.id_zastupcu
                                  )
                                    ? requiredRule
                                    : true,
                                  v => statnaPrislusnostRule(v, zas),
                                ]"
                                :items="statyData"
                                :readonly="zas.readonly"
                                item-text="displayMember"
                                item-value="valueMember"
                                v-model="zas.id_krajiny_dokladu"
                                :class="{
                                  readonly: zas.readonly,
                                  required: getZastupcaParameter(
                                    'isRequired',
                                    'id_krajiny_dokladu',
                                    zas.id_zastupcu
                                  ),
                                }"
                                :disabled="
                                  !getZastupcaParameter(
                                    'isEnabled',
                                    'id_krajiny_dokladu',
                                    zas.id_zastupcu
                                  )
                                "
                              />
                            </div>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="5">
                            <div :class="{ readonly: zas.readonly }">
                              <v-autocomplete
                                append-icon="mdi-chevron-down"
                                outlined
                                class="dynamic-input-control naked"
                                label="Pohlavie"
                                :items="pohlaviaData"
                                :readonly="zas.readonly"
                                naked
                                :rules="[
                                  getZastupcaParameter('isRequired', 'pohlavie', zas.id_zastupcu)
                                    ? requiredRule
                                    : true,
                                ]"
                                item-text="displayMember"
                                item-value="valueMember"
                                v-model="zas.pohlavie"
                                :class="{
                                  readonly: zas.readonly,
                                  required: getZastupcaParameter(
                                    'isRequired',
                                    'pohlavie',
                                    zas.id_zastupcu
                                  ),
                                }"
                                :disabled="
                                  !getZastupcaParameter('isEnabled', 'pohlavie', zas.id_zastupcu)
                                "
                              />
                            </div>
                          </v-col>
                          <v-col cols="2"></v-col>
                          <v-col cols="5">
                            <date-picker
                              :staticLabel="
                                zas.zahranicna_osoba ? 'Platnosť do' : 'Dátum platnosti'
                              "
                              :readonly="zas.readonly"
                              :class="{ readonly: zas.readonly }"
                              no-icon
                              text-only
                              naked
                              v-model="zas.platnost_do"
                              :isEnabled="
                                getZastupcaParameter('isEnabled', 'platnost_do', zas.id_zastupcu)
                              "
                              :required="
                                getZastupcaParameter('isRequired', 'platnost_do', zas.id_zastupcu)
                              "
                            />
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="5">
                            <text-box
                              :staticLabel="zas.zahranicna_osoba ? 'Číslo dokladu' : 'Číslo OP'"
                              :readonly="zas.readonly"
                              :class="{ readonly: zas.readonly }"
                              naked
                              v-model="zas.cislo_dokladu"
                              :isEnabled="
                                getZastupcaParameter('isEnabled', 'cislo_dokladu', zas.id_zastupcu)
                              "
                              :required="
                                getZastupcaParameter('isRequired', 'cislo_dokladu', zas.id_zastupcu)
                              "
                            ></text-box>
                          </v-col>
                          <v-col cols="2"></v-col>
                          <v-col cols="5">
                            <date-picker
                              label="Dátum vydania"
                              :readonly="zas.readonly"
                              :class="{ readonly: zas.readonly }"
                              no-icon
                              text-only
                              naked
                              v-model="zas.platnost_od"
                              @inputChanged="v => updateDatumPlatnosti(v, zas)"
                              :isEnabled="
                                getZastupcaParameter('isEnabled', 'platnost_od', zas.id_zastupcu)
                              "
                              :required="
                                getZastupcaParameter('isRequired', 'platnost_od', zas.id_zastupcu)
                              "
                            />
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </v-card>
                </div>
              </div>
            </v-form>
          </div>
        </v-expand-transition>
      </v-card>
      <v-btn class="btn-secondary mt-20px" @click="addZastupca()" :disabled="addZastupcaDisabled"
        >Pridať novú kontaktnú osobu</v-btn
      >
      <v-btn class="btn-primary mt-20px right" @click="ulozit()">Uložiť</v-btn>
      <v-btn class="btn-secondary mt-20px mr-20px right" to="/obchodne-pripady">Zatvoriť</v-btn>
      <kontrola-pred-schvalenim
        ref="kontrolaPredSchvalenim"
        :cisloObchPripadu="this.odoslatNaSchvalenieRequest.cisloObchPripadu"
        :cisloPredmetu="this.odoslatNaSchvalenieRequest.cisloPredmetu"
        :newId="this.odoslatNaSchvalenieRequest.newId"
        :formaPodnikania="formaPodnikania"
      />
      <v-dialog
        v-model="sendOpMobilDialog"
        overlay-color="#000"
        overlay-opacity="0.66"
        persistent
        max-width="500"
      >
        <v-card>
          <v-card-title class="d-flex justify-space-between">
            Zadajte tel. číslo pre nahratie
            {{ sendOpMobilZastupca != null ? (sendOpMobilZastupca.zahranicnaOsoba ? 'dokladu' : 'občianského preukazu') : 'občianského preukazu' }}
            <v-btn icon @click="closeSendOpMobilDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <text-box
              ref="opTelCislo"
              :rules="[telefonneCisloRule]"
              label="Zadajte tel. číslo"
              placeholder="+421"
              required
              v-model="opTelefon"
              textOnFocus="+421"
              :removeCharacters="/[^+\d]/g"
              :isPhoneNumber="true"
              :cache="false"
            ></text-box>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="btn-secondary ml-5" @click="closeSendOpMobilDialog()"> Späť </v-btn>
            <v-btn class="btn-primary" @click="sendOpMobil()"> Odoslať </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import ButtonGroup from '../components/basic/ButtonGroup.vue';
import CheckBox from '../components/basic/CheckBox.vue';
import TextBox from '../components/basic/TextBox.vue';
import MessageBox from '../components/basic/MessageBox';
import Ico from '../components/basic/TextBox.vue';
import DynamicCombo from '../components/basic/DynamicCombo.vue';
import NumericTextBox from '../components/basic/NumericTextBox.vue';
import DatePicker from '../components/basic/DatePicker.vue';
import UploadArea from '../components/basic/UploadArea.vue';
import { mapGetters, mapMutations } from 'vuex';
import protectedAxios from '../auth/axios.js';
import { comboMixin } from '../mixins/comboMixin.js';
import Utils from '../plugins/utils';
import { eventBus } from '../main.js';
import KontrolaPredSchvalenim from '../components/sumar/KontrolaPredSchvalenim.vue';
export default {
  mixins: [comboMixin],
  components: {
    ButtonGroup,
    CheckBox,
    TextBox,
    Ico,
    DynamicCombo,
    NumericTextBox,
    DatePicker,
    UploadArea,
    MessageBox,
    KontrolaPredSchvalenim,
  },
  data() {
    return {
      newId: null,
      loaded: false,
      showKor: false,
      podpisErrorMessage: '',
      isLoading: true,
      loadingMessage: 'Prebieha načítanie dát, prosím počkajte ...',
      requiredRule: value => !!value || 'Pole je povinné',
      overlayTimeout: null,

      pravnaFormaData: null,
      koncesiaData: null,
      titul1Data: null,
      titul2Data: null,
      statyData: null,
      funkcieData: null,
      pohlaviaData: null,
      id_pravnej_formy: null,
      zdrojFinProstredkovData: null,

      najomcaData: null,
      najomca: {
        cislo_obch_pripadu: null,
        id_formy_podn: null,
        podnika_na_rc: 0,
        ico: null,
        obchod_meno: null,
        ine_mena: null,
        rodne_priezvisko: null,
        neadresna: null,
        dic: null,
        ic_dph: null,
        je_platcom_dph: null,
        datum_vzniku: null,
        id_pravnej_formy: null,
        id_koncesie: null,
        id_oblast_podn_sekcie: null,
        id_oblast_podn_nace: null,
        registracia: null,
        obrat: null,
        ulica_reg: null,
        cislo_domu_reg: null,
        mesto_reg: null,
        psc_reg: null,
        id_okresu_reg: null,
        stat_reg: null,
        ulica_kor: null,
        cislo_domu_kor: null,
        mesto_kor: null,
        psc_kor: null,
        id_okresu_kor: null,
        stat_kor: null,
        titul1: null,
        titul2: null,
        iban: null,
        oblast_podn_nace_nazov: null,
        pocet_zamestnancov: null,
        id_zdroja_fin_prostriedkov: null,
      },
      formaPodnData: [
        {
          valueMember: 1,
          displayMember: 'Právnická osoba',
        },
        {
          valueMember: 2,
          displayMember: 'Fyzická osoba podnikateľ',
        },
        {
          valueMember: 3,
          displayMember: 'Fyzická osoba nepodnikateľ',
        },
      ],
      zastupcaNewId: 0,
      zastupcoviaData: null,
      zastupcovia: [],
      zastupcaTemplate: {
        show: false,
        zadatOpManualne: false,
        nahratOpDisabled: false,
        sendingRequest: false,
        openUploadDialog: false,
        uloadujemData: false,
        readonly: true,
        opUploaded: true,
        changedRC: false,
        changedFO: false,

        id_zastupcu: null,
        priezvisko: null,
        rodne_priezvisko: null,
        meno: null,
        pohlavie: null,
        titul_1: null,
        titul_2: null,
        datum_narodenia: null,
        rc: null,
        id_funkcie: null,
        doklad_typ: null,
        cislo_dokladu: null,
        platnost_od: null,
        platnost_do: null,
        id_krajiny_dokladu: 1,
        ulica: null,
        ulicaSearchData: [],
        ulicaSearchLoading: { value: false },
        psc: null,
        pscSearchData: [],
        pscSearchLoading: { value: false },
        mesto: null,
        mestoSearchData: [],
        mestoSearchLoading: { value: false },
        cislo_domu: null,
        cislo_domuSearchData: [],
        cislo_domuSearchLoading: { value: false },
        miesto_narodenia: null,
        osobitne_zaznamy: null,
        mobil: null,
        konecny_uzivatel_vyhod: null,
        je_konatel: null,
        email: null,
        zahranicna_osoba: null,
        fyzicky_overeny: null,
        identityTB: false,
        ma_profil_kz: false,
      },
      zasDebugIndex: null,
      //RFC 5322
      emailRegex: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      searchTimeout: {
        cityTimeout: null,
        streetTimeout: null,
        addressTimeout: null,
        zipTimeout: null,
      },
      formaPodnikania: null,
      opTelefon: null,
      idVytazenia: null,
      vytazenieStateTimer: null,
      sendingRequest: false,
      sendOpMobilDialog: false,
      sendOpMobilZastupca: null,
    };
  },
  computed: {
    ...mapGetters(['debug', 'pridatKontaktnuOsobu', 'odoslatNaSchvalenieRequest']),
    addZastupcaDisabled() {
      return !!this.zastupcovia.find(z => z.id_zastupcu < 0) || (
        !!this.zastupcovia.find(z => z.id_funkcie === 84) &&
        (this.najomca.id_formy_podn === 3 ||
          (this.najomca.id_formy_podn === 2 && this.najomca.podnika_na_rc))
      );
    },
  },
  watch:{
    idVytazenia(val) {
      if (val) {
        this.startGetVytazenieStateTask();
      }
    }
  },
  methods: {
    ...mapMutations(['setPridatKontaktnuOsobu','setLoadingDialog', 'openDialog', 'closeDialog']),
    openOpConfirmation(onContinue) {
      this.openDialog({
        width: 500,
        persistent: true,
        header: 'Upozornenie',
        text:
          '<span class="gs100 f16">Vyťažením občianskeho preukazu sa vytvára účet v Klientskej zóne. Prosím skontroluje zadaný email a telefónne číslo na zástupcovi.</span>',
        closeIcon: {
          value: true,
        },
        secondaryBtn: {
          text: 'Zrušiť',
          func: () => this.closeDialog(),
        },
        primaryBtn: {
          text: 'Pokračovať',
          func: () => {
            this.closeDialog();
            onContinue();
          },
        },
      });
    },
    confirmAndSendOp(zas) {
      this.openOpConfirmation(() => this.sendOp(zas));
    },
    confirmAndOpenSendOpMobilDialog(zas) {
      this.openOpConfirmation(() => this.openSendOpMobilDialog(zas));
    },
    getNajomcaParameter(paramName, parameter) {
      if (!this.najomcaData) return false;

      const elem = this.najomcaData.find(e => e.columnName.toLowerCase() === parameter);

      if (paramName === 'isEnabled') return !!elem?.isEnabled;

      if (paramName === 'isRequired') return !!elem?.isRequired;

      if (!paramName) return elem;
    },
    getZastupcaParameter(paramName, parameter, id_zastupcu) {
      if (!this.zastupcoviaData) return false;
      try {
        const zastupca = this.zastupcoviaData.find(x => {
          let x_zastupca = x.find(z => z.columnName.toLowerCase() === 'id_zastupcu');
          return (
            parseInt(
              x_zastupca.controlValue === '' || x_zastupca.controlValue == null
                ? 0
                : x_zastupca.controlValue
            ) === (id_zastupcu < 0 ? 0 : id_zastupcu)
          );
        });
        let elem = null;
        if (zastupca) elem = zastupca.find(e => e.columnName === parameter);

        if (paramName === 'isEnabled') return !!elem?.isEnabled;

        if (paramName === 'isRequired') {
          return !!elem?.isRequired;
        }

        if (!paramName) return elem;
      } catch (e) {
        console.error(paramName, parameter, id_zastupcu);
      }
    },
    getAdresa(zas) {
      const mesto = zas.mesto?.valueMember ?? zas.mesto;
      const ulica = zas.ulica?.valueMember ?? zas.ulica;
      const cisloDomu = zas.cislo_domu?.valueMember ?? zas.cislo_domu;
      const psc = zas.psc?.valueMember ?? zas.psc;

      let adr = ulica;
      if (cisloDomu) {
        adr = adr ? `${adr} ${cisloDomu}` : `${cisloDomu}`;
      }
      if (mesto) {
        adr = adr ? `${adr}, ${mesto}` : `${mesto}`;
      }
      if (psc) {
        adr = adr ? `${adr} ${psc}` : `${psc}`;
      }
      return adr;
    },

    async poslatNaPodpis() {},
    async loadCombos() {
      const comboMap = [
        ['pravne-formy', 'pravnaFormaData'],
        ['koncesie', 'koncesiaData'],
        ['tituly1', 'titul1Data'],
        ['tituly2', 'titul2Data'],
        ['staty', 'statyData'],
        ['funkcie', 'funkcieData'],
        ['pohlavia', 'pohlaviaData'],
      ];

      let promises = [];

      comboMap.forEach(cm => {
        promises.push(
          protectedAxios.get(`cis/${cm[0]}`).then(res => {
            this[cm[1]] = res.data;
          })
        );
      });

      return Promise.all(promises);
    },
    loadZdrojFinProstriedkov() {
      const idFormyPodn = this.najomca.id_formy_podn;

      if (![1, 2].includes(idFormyPodn)) {
        this.zdrojFinProstredkovData = [];
        return Promise.resolve([]);
      }

      return protectedAxios
        .get('cis/sco-prijem', {
          params: {
            idFormyPodn: idFormyPodn,
          },
        })
        .then(res => {
          this.zdrojFinProstredkovData = res.data;
          return res.data;
        });
    },
    removeZastupca(zastupca) {
      const index = this.zastupcovia.indexOf(zastupca);
      if (index > -1) {
        this.zastupcovia.splice(index, 1);
      }
    },
    addZastupca() {
      const zastupca = { ...this.zastupcaTemplate };
      zastupca.show = true;
      zastupca.id_zastupcu = --this.zastupcaNewId;

      if (
        this.najomca.id_formy_podn === 3 ||
        (this.najomca.id_formy_podn === 2 && this.najomca.podnika_na_rc)
      )
        zastupca.id_funkcie = 84; //84 - spoludlznik

      this.zastupcovia.push(zastupca);

      setTimeout(() => {
        this.$vuetify.goTo(`#zastupca${zastupca.id_zastupcu}`, {
          duration: 500,
          easing: 'easeInOutCubic',
        });
      }, 200);
    },
    getZastupcoviaDebugEntries() {
      if (this.zastupcovia && this.zasDebugIndex !== null)
        return Object.entries(this.zastupcovia[this.zasDebugIndex]);
      else return [];
    },
    openCloseZastupca(zas) {
      zas.show = !zas.show;

      if (zas.show) {
        setTimeout(() => {
          this.$vuetify.goTo(`#zastupca${zas.id_zastupcu}`, {
            duration: 500,
            easing: 'easeInOutCubic',
          });
        }, 50);
      }
    },
    ulozit() {
      let isValid = this.$refs.form.validate();
      let scrollTo = null;
      let opUploaded = false;

      for (let i = 0; i < this.zastupcovia.length; i++) {
        const zastupca = this.zastupcovia[i];
        const formOp = this.$refs['form_op_' + zastupca.id_zastupcu][0].validate();
        const formManual = this.$refs['form_manual_' + zastupca.id_zastupcu][0].validate();
        opUploaded = zastupca.opUploaded;
        this.zastupcovia[i].doklad_typ = zastupca.zahranicna_osoba ? 4 : 1;

        if (!formOp || !formManual || !zastupca.opUploaded || this.ibanError) {
          scrollTo = '#zastupca' + zastupca.id_zastupcu;
          isValid = isValid && formOp && formManual && !this.ibanError;
          zastupca.show = true;
          zastupca.zadatOpManualne = !formManual;

          break;
        }
      }

      if (scrollTo)
        setTimeout(() => {
          this.$vuetify.goTo(scrollTo, { duration: 500, easing: 'easeInOutCubic' });
        }, 200);
      else if (!scrollTo && !isValid) {
        this.showKor = true;
        this.$vuetify.goTo(0, { duration: 500, easing: 'easeInOutCubic' });
      }

      if (!isValid) {
        eventBus.$emit('snack-error', 'Pre uloženie prosím vyplňte všetky povinné polia!');
        return;
      }

      if (!opUploaded) {
        eventBus.$emit('snack-error', 'Prosím nahrajte doklad!');
        return;
      } else {
        if (
          (this.najomca.id_formy_podn === 2 && this.najomca.podnika_na_rc === 1) ||
          this.najomca.id_formy_podn === 3
        ) {
          this.najomca.ico = this.zastupcovia.find(z => z.id_funkcie !== 84).rc;
          this.najomca.neadresna = 0;
        }
      }

      const spoludlznici = this.zastupcovia.filter(z => z.id_funkcie === 84);
      if (spoludlznici.length > 1) {
        eventBus.$emit('snack-error', 'Zástupca označený ako spolužiadateľ može byť iba jeden!');
        spoludlznici.forEach(z => {
          z.show = true;
        });
        setTimeout(() => {
          this.$vuetify.goTo('#zastupca' + spoludlznici[0].id_zastupcu, {
            duration: 500,
            easing: 'easeInOutCubic',
          });
        }, 50);

        return;
      }

      const identityTB = this.zastupcovia.filter(z => z.identityTB == 1);
      const fyzickeOverenie = this.zastupcovia.filter(z => z.changedFO && z.fyzicky_overeny == 1);

      this.loadingMessage = 'Prebieha ukladanie dát, prosím počkajte ...';
      this.setLoading(true);

      const najomcaSaveData = Utils.modelToPostData(this.najomca);
      const zastupcoviaSaveData = [];
      this.zastupcovia.forEach(zas => {
        if (zas.mesto?.valueMember) zas.mesto = zas.mesto?.valueMember;
        if (zas.ulica?.valueMember) zas.ulica = zas.ulica?.valueMember;
        if (zas.cislo_domu?.valueMember) zas.cislo_domu = zas.cislo_domu?.valueMember;
        if (zas.psc?.valueMember) zas.psc = zas.psc?.valueMember;

        zastupcoviaSaveData.push(Utils.modelToPostData(zas));
      });

      protectedAxios
        .post(
          `/pripady/${this.newId}/najomca`,
          { data: najomcaSaveData, zastupcovia: zastupcoviaSaveData },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        .then(async () => {
          if (identityTB.length > 0) {
            let promises = [];
            for(let i = 0; i < identityTB.length; i++){
              promises.push(() => this.sendIdentityTB(identityTB[i]));
            }
            return await Promise.all(promises.map(p =>
              p().catch(e => {
                return Promise.reject(e);
              })
            ));
          }else{
            return Promise.resolve();
          }
        })
        .then(async () => {
          if (fyzickeOverenie.length > 0) {
            let promises = [];
            for(let i = 0; i < fyzickeOverenie.length; i++){
              promises.push(() => this.setFyzickeOverenie(Math.abs(fyzickeOverenie[i].id_zastupcu)));
            }
            return await Promise.all(promises.map(p =>
              p().catch(e => {
                return Promise.reject(e);
              })
            ));
          }else{
            return Promise.resolve();
          }
        })
        .then(() => {
          eventBus.$emit('snack-info', 'Dáta boli úspešne uložené.');

          return this.nacitajData();
        })
        .then(() => {
          return this.odoslanieNaSchvalenieCheck();
        })
        .then(() => this.setLoading(false))
        .catch(e => {
          this.setLoading(false);
        });
    },
    onRodneCisloInput(v, zas) {
      if (zas.rc.length > 0) {
        zas.changedRC = true;
        zas.opUploaded = false;
      } else {
        zas.changedRC = false;
        if(!zas.changedFO)
        zas.opUploaded = true;
    }
    this.checkProfilVKZ(zas);
      if (!zas.zahranicna_osoba) {
        const rdcObj = this.parseRdc(v);
        zas.datum_narodenia = rdcObj.datum;
        zas.pohlavie = rdcObj.pohlavie;
      }
    },
    nastavFyzickeOverenie(v, zas) {
      if (v) {
        zas.changedFO = true;
        if(zas.changedRC)
          zas.opUploaded = false;
      } else {
        zas.changedFO = false;
        if(!zas.changedRC)
          zas.opUploaded = true;
      }
      if (!zas.zahranicna_osoba) {
        const rdcObj = this.parseRdc(zas.rc.toString());
        zas.datum_narodenia = rdcObj.datum;
        zas.pohlavie = rdcObj.pohlavie;
      }
    },
    async checkProfilVKZ(zas){
      if(zas.email == null || zas.email == '' || zas.rc == null || zas.rc == "" || (zas.id_zastupcu_leasit != null && zas.id_zastupcu_leasit != ""))
        return;
      await protectedAxios.get(`/pripady/check-profil-v-kz?email=${encodeURIComponent(
        zas.email
      )}&rodneCislo=${zas.rc}&ico=${this.najomca.ico}`)
      .then((res)=>{
        if(res){
          zas.ma_profil_kz = res;
        }
      })
      .catch(e => {
        console.error(e);
        eventBus.$emit('snack-error', e);
      });
    },
    //vrati object {datum: .., pohlavie: ..}
    parseRdc(rdc) {
      const obj = { datum: null, pohlavie: null };
      const koncovka = rdc.substring(6, 12);
      const y = rdc.substring(0, 2);
      const m = rdc.substring(2, 4);
      const d = rdc.substring(4, 6);

      let datum = '';

      if (koncovka.length === 3) datum += '19';
      else if (koncovka.length === 4 && Number(y) >= 54) datum += '19';
      else datum += '20';
      datum += y;
      datum += '-';
      if (m.charAt(0) === '5') datum += '0' + m.charAt(1);
      else if (m.charAt(0) === '6') datum += '1' + m.charAt(1);
      else datum += m;
      datum += '-';
      datum += d;

      obj.pohlavie = Number(m) > 50 ? 2 : 1;
      obj.datum = datum;

      return obj;
    },
    statnaPrislusnostRule(v, zas) {
      if (!v) return true;
      if (!!zas.zahranicna_osoba && v === 1) return 'Zahraničná osoba ≠ Slovenská republika';
      return true;
    },
    setIdentityTB(zas){
      if(zas.id_zastupcu > 0){
        this.sendIdentityTB(zas);
      }else{
        zas.identityTB = true
      }
    },
    async sendIdentityTB(zas) {
      return await protectedAxios.post(`/pripady/${this.newId}/najomca/send-identityTB`,{
        email: zas.email,
          idZastupcu: Math.abs(zas.id_zastupcu),
          idFunkcie: zas.id_funkcie,
      }).catch(e => {
        console.error(e);
        eventBus.$emit('snack-error', e);
      });
    },
    async sendOp(zas) {
      var ico = this.najomca.ico;
      const kuv = zas.konecny_uzivatel_vyhod == 1 ? true : false;
      const statutar = zas.je_konatel == 1 ? true : false;
      const zahranicnaOsoba = zas.zahranicna_osoba == 1 ? true : false;
      const idFunkcie = zas.id_funkcie;
      const podnikaNaRc = this.najomca.podnika_na_rc == 1;
      const returnUrl = window.location.href;
      return await protectedAxios
        .post(`/pripady/${this.newId}/send-op`, {
          pageContext: 'Eclient_frmNajomca',
          email: zas.email,
          telefon: zas.mobil,
          obchMeno: this.najomca.obchod_meno,
          ico: ico + "",
          idFormaPodnikania: this.najomca.id_formy_podn,
          idZastupcu: Math.abs(zas.id_zastupcu),
          kuv: kuv,
          statutar: statutar,
          zahranicnaOsoba: zahranicnaOsoba,
          idFunkcie: idFunkcie,
          podnikaNaRc: podnikaNaRc,
          physicalVerification: zas.fyzicky_overeny == 1 ? true : false,
          returnUrl: returnUrl,
        })
        .then(res => {
          if (res.data.error > 0) {
            eventBus.$emit('snack-error', res.data.errorText);
          } else {
            this.saveBrowserCache();
            window.onbeforeunload = null;
            window.location.href = res.data.url;
          }
        })
        .catch(e => {
          console.error(e);
          eventBus.$emit('snack-error', e);
        });
    },
    async sendOpMobil() {
      var ico = this.najomca.ico;
      const kuv = this.sendOpMobilZastupca.konecny_uzivatel_vyhod == 1 ? true : false;
      const statutar = this.sendOpMobilZastupca.je_konatel == 1 ? true : false;
      const zahranicnaOsoba = this.sendOpMobilZastupca.zahranicna_osoba == 1 ? true : false;
      const idFunkcie = this.sendOpMobilZastupca.id_funkcie;
      const podnikaNaRc = this.najomca.podnika_na_rc == 1;
      const returnUrl = window.location.href;
      this.setLoadingDialog({
        open: true,
        btext: 'Prebieha proces vyťažovania dokladu...',
        utext: 'Dokončite proces na mobilnom zariadení.',
      });
      return await protectedAxios 
        .post(`/pripady/${this.newId}/send-op-mobil`, {
          pageContext: 'Eclient_frmNajomca',
          email: this.sendOpMobilZastupca.email,
          telefon: this.sendOpMobilZastupca.mobil,
          telefonSendLink: this.opTelefon,
          obchMeno: this.najomca.obchod_meno,
          ico: ico + "",
          idFormaPodnikania: this.najomca.id_formy_podn,
          idZastupcu: Math.abs(this.sendOpMobilZastupca.id_zastupcu),
          kuv: kuv,
          statutar: statutar,
          zahranicnaOsoba: zahranicnaOsoba,
          idFunkcie: idFunkcie,
          podnikaNaRc: podnikaNaRc,
          physicalVerification: this.sendOpMobilZastupca.fyzicky_overeny == 1 ? true : false,
          returnUrl: returnUrl,
        })
        .then(res => {
          this.closeSendOpMobilDialog();
          this.opTelefon = null;
          if (res.data.error > 0) {
            eventBus.$emit('snack-error', res.data.errorText);
            this.setLoadingDialog();
          } else {
            this.saveBrowserCache();
            this.idVytazenia = res.data.idVytazenia;
          }
        })
        .catch(e => {
          console.error(e);
          eventBus.$emit('snack-error', e);
          this.setLoadingDialog();
        });
    },
    saveBrowserCache(){
      let cache = {
        registracia: this.najomca.registracia,
        datum_vzniku: this.najomca.datum_vzniku,
        je_platcom_dph: this.najomca.je_platcom_dph,
        id_pravnej_formy: this.najomca.id_pravnej_formy,
        id_koncesie: this.najomca.id_koncesie,
        ic_dph: this.najomca.ic_dph,
        dic: this.najomca.dic,
        ulica_reg: this.najomca.ulica_reg,
        cislo_domu_reg: this.najomca.cislo_domu_reg,
        mesto_reg: this.najomca.mesto_reg,
        psc_reg: this.najomca.psc_reg,
        stat_reg: this.najomca.stat_reg,
        ulica_kor: this.najomca.ulica_kor,
        cislo_domu_kor: this.najomca.cislo_domu_kor,
        mesto_kor: this.najomca.mesto_kor,
        psc_kor: this.najomca.psc_kor,
        stat_kor: this.najomca.stat_kor,
        iban: this.najomca.iban
      }
      localStorage.setItem(this.newId,JSON.stringify(cache));

      if(this.odoslatNaSchvalenieRequest.newId &&
      this.odoslatNaSchvalenieRequest.cisloPredmetu){
        localStorage.setItem("odoslanieNaSchvalenie" + this.newId,
        JSON.stringify(
          {
            newId: this.odoslatNaSchvalenieRequest.newId, 
            cisloPredmetu: this.odoslatNaSchvalenieRequest.cisloPredmetu, 
            cisloObchPripadu: this.odoslatNaSchvalenieRequest.cisloObchPripadu,
            varianty: this.odoslatNaSchvalenieRequest.varianty,
          }))
      }
    },
    loadBrowserCache(){
      const cache = JSON.parse(localStorage.getItem(this.newId));
      if(cache != null){
          this.najomca.registracia = cache.registracia;
          this.najomca.datum_vzniku = cache.datum_vzniku;
          this.najomca.je_platcom_dph = cache.je_platcom_dph;
          this.najomca.id_pravnej_formy = cache.id_pravnej_formy;
          this.najomca.id_koncesie = cache.id_koncesie;
          if(this.najomca.id_formy_podn == 1 || (this.najomca.id_formy_podn == 2 && this.najomca.podnika_na_rc != 1))
          {
            this.najomca.ic_dph = cache.ic_dph;
            this.najomca.dic = cache.dic;
            this.najomca.ulica_reg = cache.ulica_reg;
            this.najomca.cislo_domu_reg = cache.cislo_domu_reg;
            this.najomca.mesto_reg = cache.mesto_reg;
            this.najomca.psc_reg = cache.psc_reg;
            this.najomca.stat_reg = cache.stat_reg;
            this.najomca.ulica_kor = cache.ulica_kor;
            this.najomca.cislo_domu_kor = cache.cislo_domu_kor;
            this.najomca.mesto_kor = cache.mesto_kor;
            this.najomca.psc_kor = cache.psc_kor;
            this.najomca.stat_kor = cache.stat_kor;
            this.najomca.iban = cache.iban;
          }

          localStorage.removeItem(this.newId);
        }

      const cacheOdoslanieNaSchvalenie = JSON.parse(localStorage.getItem("odoslanieNaSchvalenie" + this.newId));
      if(cacheOdoslanieNaSchvalenie != null){
        this.odoslatNaSchvalenieRequest.newId = cacheOdoslanieNaSchvalenie.newId;
        this.odoslatNaSchvalenieRequest.cisloPredmetu = cacheOdoslanieNaSchvalenie.cisloPredmetu;
        this.odoslatNaSchvalenieRequest.cisloObchPripadu = cacheOdoslanieNaSchvalenie.cisloObchPripadu;
        this.odoslatNaSchvalenieRequest.varianty = cacheOdoslanieNaSchvalenie.varianty;

        localStorage.removeItem("odoslanieNaSchvalenie" + this.newId);
      }
    },
    startGetVytazenieStateTask() {
      this.vytazenieStateTimer = setInterval(() => {
        this.getVytazenie();
      }, 3000);
    },

    async getVytazenie() {
      return await protectedAxios
        .get(`/pripady/${this.newId}/vytazenie?idVytazenia=${this.idVytazenia}`)
        .then(res => {
          if (res.data.status == 'success') {
            clearInterval(this.vytazenieStateTimer);
            this.setLoadingDialog();
            this.idVytazenia = null;
            window.location.reload();
          }
          if (res.data.status == 'in_progress') {
            this.setLoadingDialog({
              open: true,
              btext: 'Prebieha proces vyťažovania dokladu...',
              utext: 'Dokončite proces na mobilnom zariadení.',
            });
            return;
          }
          if (res.data.status == 'fail') {
            clearInterval(this.vytazenieStateTimer);
            eventBus.$emit('snack-error', "Nepodarilo sa spracovať údaje z OP. Skúste to neskôr.");
            this.setLoadingDialog();
            this.idVytazenia = null;
          }
        })
        .catch(e => {
          console.error(e);
          clearInterval(this.vytazenieStateTimer);
          this.idVytazenia = null;
        });
    },
    async setFyzickeOverenie(idZastupcu) {
      return await protectedAxios
        .post(`/pripady/${this.newId}/fyzicke-overenie?idZastupcu=${idZastupcu}&najomca=true`)
        .then(res => {
          if (res.data.error > 0) {
            eventBus.$emit('snack-error', res.data.errorText);
            return Promise.reject(false);
          }
        })
        .catch(e => {
          console.error(e);
        });
    },
    sendOpRequest(email, mobil, menoPriezvisko, zahranicny) {
      this.sendingRequest = true;

      protectedAxios
        .get('/otp/sendOpRequest', {
          params: {
            newId: this.newId,
            email: email,
            mobil: mobil,
            menoPriezvisko: menoPriezvisko,
            zahranicny: zahranicny,
          },
        })
        .then(res => {
          eventBus.$emit(res.data.error ? 'snack-error' : 'snack-info', res.data.text);
          this.sendingRequest = false;
        })
        .catch(e => {
          eventBus.$emit('snack-error', 'Pri odosielaní emailu nájomcovi nastala chyba.');
          this.sendingRequest = false;
        });
    },
    async dmsSave(zas) {
      this.$refs['refuploadarea' + zas.id_zastupcu][0].filesSaved(() => {
        zas.uloadujemData = false;
        zas.openUploadDialog = false;
      });
      this.$refs['refuploadarea' + zas.id_zastupcu][0].filesNotSaved(() => {
        zas.uloadujemData = false;
      });
      zas.uloadujemData = true;
      this.$refs['refuploadarea' + zas.id_zastupcu][0].save(
        zas.zahranicna_osoba ? 600 : 128,
        zas.zahranicna_osoba
          ? 'Povolenie na pobyt'
          : 'Občiansky' + ' z IS LIW Filip pre zástupcu:' + zas.meno + ' ' + zas.priezvisko,
          this.newId
      );
    },
    telefonneCisloRule(v) {
      if (!v) return true;
      if (!/^\+/.test(v)) return 'Telefónne číslo musí začínať znakom +';
      if (v.length < 10) return 'Nie je vyplnené telefónne číslo';
      if (!/^(\+)[0-9]*$/.exec(v)) return 'Telefónne číslo može obsahovať iba číslice';
      return true;
    },
    nacitajData() {
      this.loadingMessage = 'Prebieha načítanie dát, prosím počkajte ...';
      //nacitanie dat najomcu
      const najomcaPromise = protectedAxios
        .get(`/pripady/${this.newId}/najomca/`, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(res => {
          // console.log(
          //   res.data.map(x => ({
          //     cn: x.columnName,
          //     cv: x.controlValue,
          //     en: x.isEnabled,
          //     req: x.isRequired,
          //   }))
          // );

          if (res.data) {
            this.$set(this, 'najomcaData', res.data);
            // this.najomcaData = res.data;

            this.najomcaData
              .map(x => x.columnName.toLowerCase())
              .forEach(key => {
                const val = res.data.find(e => e.columnName.toLowerCase() === key)?.controlValue;

                const intVal = val?.toStrictInt();

                this.najomca[key] = !intVal && intVal !== 0 ? val : intVal;
              });

            this.loadBrowserCache();
          }
        });
      //nacitanie dat zastupcov
      const zastupcaPromise = protectedAxios
        .get(`/pripady/${this.newId}/najomca/zastupcovia`, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(res => {
          // console.log(
          //   res.data.map(x =>
          //     x.map(y => ({
          //       cn: y.columnName,
          //       cv: y.controlValue,
          //       en: y.isEnabled,
          //       req: y.isRequired,
          //     }))
          //   ),
          //   res.data
          // );

          this.zastupcoviaData = [];
          this.zastupcovia = [];
          let pomZastupcovia = [];

          if (res.data && res.data.length > 0) {
            this.$set(this, 'zastupcoviaData', res.data);
            // this.zastupcoviaData = res.data;

            this.zastupcoviaData.forEach(data => {
              if (!data.find(z => z.columnName === 'id_zastupcu').controlValue) return;

              const zastupca = { ...this.zastupcaTemplate };

              Object.entries(zastupca).forEach(e => {
                const [key, value] = e;

                const dataObj = data.find(e => e.columnName.toLowerCase() === key);

                if (dataObj) {
                  const intVal = dataObj.controlValue?.toStrictInt();
                  zastupca[key] = !intVal && intVal !== 0 ? dataObj.controlValue : intVal;
                } else zastupca[key] = value;
              });
              pomZastupcovia.push(zastupca);
            });
            this.$set(this, 'zastupcovia', pomZastupcovia);
            if (this.zastupcovia[0].rc.length > 0) {
              //ma najomca nahraty doklad?
              protectedAxios
                .get(`/pripady/${this.newId}/check-op-uploaded`)
                .then(res => (this.zastupcovia[0].opUploaded = res.data));
            } else {
              this.zastupcovia[0].opUploaded = true;
            }

            //kazdy dalsi ulozeny zastupca uz musi mat nahraty doklad
            for (let index = 1; index < this.zastupcovia.length; index++) {
              this.zastupcovia[index].opUploaded = true;
            }

            this.zastupcovia.forEach(zas => {
              this.searchCity(zas.mesto, zas, 3, 0, true)
                .then(r => this.searchStreets(zas.ulica, zas, 3, 0, true))
                .then(r => this.searchAddresses(zas.cislo_domu, zas, 3, 0, true))
                .then(r => this.searchZIP(zas.psc, zas, 0, true));
            });
          }
        });
      return Promise.all([zastupcaPromise, najomcaPromise]).finally(() => {
        const lastIdZastupcu = this.zastupcovia.reduce((max, zas) => Math.max(max, zas.id_zastupcu), 0);
        this.zastupcaNewId = -(lastIdZastupcu)
        this.setLoading(false);
      });
    },
    async odoslanieNaSchvalenieCheck() {
      if (
        this.odoslatNaSchvalenieRequest.newId &&
        this.odoslatNaSchvalenieRequest.varianty.length > 0
      ) {
        let varianty = await protectedAxios
          .get(
            `sumar/varianty?newId=${this.odoslatNaSchvalenieRequest.newId}&cisloPredmetu=${this.odoslatNaSchvalenieRequest.varianty[0].cisloPredmetu}`,
            {
              headers: {
                'Content-Type': 'application/json',
              },
            }
          )
          .then(res => {
            return res.data;
          });
          let pomSelectedVarianty = this.odoslatNaSchvalenieRequest.varianty.length > 0 ? varianty.filter(
            v =>{
              return this.odoslatNaSchvalenieRequest.varianty.some(v2 => v2.pkid === v.pkid);
            }
          ) : null;
          if (pomSelectedVarianty.length > 0) {
            let selectedVarianty = pomSelectedVarianty.map(v=>{
              return {
                ...v,
                cisloPredmetu: this.odoslatNaSchvalenieRequest.varianty.find(v2 => v2.pkid === v.pkid)?.cisloPredmetu ?? 0
              }
            })
            this.$refs.kontrolaPredSchvalenim.execute(selectedVarianty);
          }
      }
    },
    setLoading(val) {
      clearTimeout(this.overlayTimeout);

      if (!val)
        this.overlayTimeout = setTimeout(() => {
          this.isLoading = false;
        }, 200);
      else this.isLoading = true;
    },

    nastavObcianstvo(val, zas) {
      if (val === 1) zas.id_krajiny_dokladu = null;
      else zas.id_krajiny_dokladu = 1;
    },
    updateDatumPlatnosti(v, zas) {
      if (zas.zahranicna_osoba) return;
      const d = new Date(v);
      zas.platnost_do = new Intl.DateTimeFormat('sv-SE')
        .format(d.setFullYear(d.getFullYear() + 10))
        .split(' ')[0];
    },
    searchCity(val, zas, searchMinCharacters = 3, delay = 500, isInit = false) {
      if ((!zas || val === zas.mesto || (zas.mesto && val === zas.mesto?.valueMember)) && !isInit)
        return Promise.resolve();
      zas.mestoSearchData = [];
      if (!val || val.length < searchMinCharacters) {
        return Promise.resolve();
      }

      clearTimeout(this.searchTimeout.cityTimeout);
      zas.mestoSearchLoading.value = true;

      return new Promise(
        (parentRes, _) =>
          (this.searchTimeout.cityTimeout = setTimeout(() => {
            protectedAxios.get(`cis/address/cities?query=${val ?? ''}`).then(res => {
              if (res.data && res.data.length > 0) {
                zas.mestoSearchData.push(...res.data);

                if (isInit) zas.mesto = zas.mestoSearchData[0];
              }
              zas.mestoSearchLoading.value = false;
              parentRes();
            });
          }, delay))
      );
    },
    searchStreets(val, zas, delay = 500, searchMinCharacters = 3, isInit = false) {
      if (!zas) return Promise.resolve();
      if (!zas.mesto?.id && !zas.mesto?.valueMember) return Promise.resolve();
      let cityId = 0;
      if (zas.mesto?.id) cityId = zas.mesto?.id;

      if ((val === zas.ulica || val === zas.ulica?.valueMember) && !isInit)
        return Promise.resolve();
      zas.ulicaSearchData = [];
      if (!val || val.length < searchMinCharacters) {
        return Promise.resolve();
      }

      clearTimeout(this.searchTimeout.streetTimeout);
      zas.ulicaSearchLoading.value = true;

      return new Promise(
        (parentRes, _) =>
          (this.searchTimeout.streetTimeout = setTimeout(() => {
            protectedAxios
              .get(
                `cis/address/streets?cityId=${cityId}&&cityName=${
                  zas.mesto?.valueMember ?? ''
                }&query=${val ?? ''}`
              )
              .then(res => {
                if (res.data && res.data.length > 0) {
                  zas.ulicaSearchData.push(...res.data);

                  if (isInit) zas.ulica = zas.ulicaSearchData[0];
                }
                zas.ulicaSearchLoading.value = false;

                parentRes();
              });
          }, delay))
      );
    },
    searchAddresses(val, zas, searchMinCharacters = 3, delay = 500, isInit = false) {
      if (!zas) return Promise.resolve();
      if (!zas.ulica?.id) return Promise.resolve();
      if ((val === zas.cislo_domu || val === zas.cislo_domu?.valueMember) && !isInit)
        return Promise.resolve();
      zas.cislo_domuSearchData = [];
      if (!val || val.length < searchMinCharacters) {
        return Promise.resolve();
      }
      clearTimeout(this.searchTimeout.addressTimeout);
      zas.cislo_domuSearchLoading.value = true;

      return new Promise(
        (parentRes, _) =>
          (this.searchTimeout.addressTimeout = setTimeout(() => {
            protectedAxios
              .get(`cis/address/addresses?streetId=${zas.ulica?.id ?? ''}&query=${val ?? ''}`)
              .then(res => {
                if (res.data && res.data.length > 0) {
                  zas.cislo_domuSearchData.push(...res.data);

                  if (isInit) zas.cislo_domu = zas.cislo_domuSearchData[0];
                }
                zas.cislo_domuSearchLoading.value = false;

                parentRes();
              });
          }, delay))
      );
    },
    searchZIP(val, zas, delay = 500, isInit = false) {
      if ((!val && !isInit) || !zas.cislo_domu) return Promise.resolve();

      if (!zas) return Promise.resolve();
      if (!zas.cislo_domu?.id && !zas.mesto?.valueMember) return Promise.resolve();
      if ((val === zas.psc || val === zas.psc?.valueMember) && !isInit) return Promise.resolve();
      let addressId = 0;
      if (zas.cislo_domu?.id) addressId = zas.cislo_domu?.id;
      zas.pscSearchData = [];

      clearTimeout(this.searchTimeout.pscTimeout);
      zas.pscSearchLoading.value = true;

      return new Promise(
        (parentRes, _) =>
          (this.searchTimeout.pscTimeout = setTimeout(() => {
            protectedAxios
              .get(
                `cis/address/zip?addressId=${addressId}&cityName=${
                  zas.mesto?.valueMember ?? ''
                }&query=${val ?? ''}`
              )
              .then(res => {
                if (res.data && res.data.length > 0) {
                  zas.pscSearchData.push(...res.data);
                  if (isInit || zas.pscSearchData.length === 1) zas.psc = zas.pscSearchData[0];
                }
                zas.pscSearchLoading.value = false;
                parentRes();
              });
          }, delay))
      );
    },
    cityOnChange(val, zas) {
      zas.ulica = null;
      zas.ulicaSearchData = [];
      zas.cislo_domu = null;
      zas.cislo_domuSearchData = [];
      zas.psc = null;
      zas.pscSearchData = [];
    },
    streetOnChange(val, zas) {
      zas.cislo_domu = null;
      zas.cislo_domuSearchData = [];
      zas.psc = null;
      zas.pscSearchData = [];
    },
    addressOnChange(val, zas) {
      if (!zas.cislo_domu) zas.psc = null;
      this.searchZIP(null, zas, 0, true);
    },
    getFormaPodnikania(){
      return protectedAxios.get(`sumar/formaPodnikania?newId=${this.newId}`).then(res => {
        this.formaPodnikania = res.data;
      })
    },
    async checkCorrectnessIban(iban){
      this.$refs['iban'].errorMessages = "";
      this.ibanError = false;
      if(iban == null || iban == ""){
        return;
      }
      return await protectedAxios.get(`pripady/checkCorrectnessIban?iban=${iban}`).then(res => {
        this.ibanError = res.data.error;
        if(!res.data.error){
          this.najomca.iban = res.data.iban;
        }else{
          this.$refs['iban'].errorMessages = "IBAN má nesprávny formát";
        }
      })
    },
    openSendOpMobilDialog(zas){
      this.sendOpMobilZastupca = zas;
      this.sendOpMobilDialog = true;
    },
    closeSendOpMobilDialog(){
      this.sendOpMobilDialog = false;
      this.sendOpMobilZastupca = null;
    }
  },
  async mounted() {
    this.newId = this.$route.params.new_id;

    await this.loadCombos();
    await this.nacitajData();
    await this.loadZdrojFinProstriedkov();
    await this.getFormaPodnikania();

    if (this.pridatKontaktnuOsobu) {
      this.setPridatKontaktnuOsobu(false);
      if (!this.addZastupcaDisabled) this.addZastupca();
    }
  },
};
</script>
<style lang="sass">
.debug-card
  position: fixed !important
  width: 300px
  height: 800px
  overflow: scroll

th
  text-align: right

.debug-najomca
  right: 0
</style>
